import { OWNER } from "modules/Call/common/constants"
import { SentryWrapper } from "utils/ThirdParty/Sentry/SentryWrapper"
import { httpClientKeepAlive } from "utils/infrastructure/httpClient"

const KEEPALIVE_BODY_LIMIT_UTF16 = (64 * 1024) / 2

function catchError(err: unknown) {
    SentryWrapper.getInstance().captureException(
        new Error("VoximplantLogger: error while sending logs"),
        { extra: { err } }
    )
    return undefined
}

export function createVoximplantLogSender(owner: OWNER, hash: string) {
    let p = Promise.resolve()
    return function (log: string) {
        const size = log.length
        if (size >= KEEPALIVE_BODY_LIMIT_UTF16) {
            const maxChunks = Math.ceil(size / KEEPALIVE_BODY_LIMIT_UTF16)
            let chunks = 0
            while (chunks < maxChunks) {
                const start = chunks * KEEPALIVE_BODY_LIMIT_UTF16
                const end = Math.min((chunks + 1) * KEEPALIVE_BODY_LIMIT_UTF16, size)
                p = p.then(
                    () =>
                        httpClientKeepAlive.post(
                            `call/v2/${owner}/log/${hash}`,
                            log.slice(start, end)
                        ),
                    catchError
                )
                ++chunks
            }
        } else {
            p = p.then(
                () => httpClientKeepAlive.post(`call/v2/${owner}/log/${hash}`, log),
                catchError
            )
        }
        return p
    }
}
